export default __webpack_public_path__ + "static/media/ods1.4f802f72.svg";